module.exports = __webpack_public_path__ + "static/Hydrofory-pionowe-HPB-fdd4904011e63081047757f411ef9bd1.pdf";